import type { FlattenedArticleItem } from '@/types/article-collection';

/**
 * Find the previous and next articles relative to the current article.
 */
export function findAdjacentArticles(
  flattened: FlattenedArticleItem[],
  currentArticleId: string
): { prev: FlattenedArticleItem | null; next: FlattenedArticleItem | null } {
  const currentIndex = flattened.findIndex(
    (item) => item.article_id === currentArticleId
  );

  if (currentIndex === -1) {
    return { prev: null, next: null };
  }

  return {
    prev: currentIndex > 0 ? flattened[currentIndex - 1] : null,
    next: currentIndex < flattened.length - 1 ? flattened[currentIndex + 1] : null,
  };
}

/**
 * Get the current article's position info for display
 */
export function getArticlePositionInfo(
  flattened: FlattenedArticleItem[],
  currentArticleId: string
): { current: number; total: number } | null {
  const currentIndex = flattened.findIndex(
    (item) => item.article_id === currentArticleId
  );

  if (currentIndex === -1) {
    return null;
  }

  return {
    current: currentIndex + 1,
    total: flattened.length,
  };
}
